import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  BETWEEN_HOURS,
  MENU_HOURS_EXPIRED,
  CHANGE_LOCATION,
  CART_ITEMS_EXPIRED
} from 'bento-ordering/cart/constants/notificationTypes';
import BetweenMenusNotificationContainer from 'bento-ordering/base/containers/BetweenMenusNotificationContainer';
import MenuHoursExpiredNotificationContainer from 'bento-ordering/base/containers/MenuHoursExpiredNotificationContainer';
import LocationChangedNotificationContainer from 'bento-ordering/base/containers/LocationChangedNotificationContainer';
import CartItemsExpiredNotificationContainer from 'bento-ordering/base/containers/CartItemsExpiredNotificationContainer';
import { closeNotificationModal } from 'bento-ordering/base/actions/notificationModals';
import ModalRoot from 'bento-ordering/base/containers/ModalRoot';

class NotificationModalContainer extends React.Component {
  static propTypes = {
    notificationModalType: PropTypes.oneOf([
      BETWEEN_HOURS,
      MENU_HOURS_EXPIRED,
      CHANGE_LOCATION,
      CART_ITEMS_EXPIRED
    ]),
    dispatch: PropTypes.func
  };

  closeModal = () => {
    this.props.dispatch(closeNotificationModal());
  };

  render() {
    const { notificationModalType } = this.props;
    return (
      <ModalRoot>
        {notificationModalType === BETWEEN_HOURS && (
          <BetweenMenusNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === MENU_HOURS_EXPIRED && (
          <MenuHoursExpiredNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === CHANGE_LOCATION && (
          <LocationChangedNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === CART_ITEMS_EXPIRED && (
          <CartItemsExpiredNotificationContainer closeModal={this.closeModal} />
        )}
      </ModalRoot>
    );
  }
}

const mapStateToprops = state => {
  return {
    notificationModalType: state.notificationModal.notificationType
  };
};

export default connect(mapStateToprops)(NotificationModalContainer);
